import { useMemo } from 'react';

import { DocumentStatusIcon } from './DocumentStatusIcon';
import { DocumentStatusText } from './DocumentStatusText';
import { ArrowButton } from 'components/Buttons/ArrowButton';
import { ContentListItem } from 'components/ContentBox/ContentListItem';
import { DocumentStatusEnum } from '../../../../common/document/enums/document-status.enum';
import { IDriverDocument } from '../../../../common/document/interfaces/driver-document';
import styles from './styles.module.scss';

type InputProps = {
  document: IDriverDocument;
  noStatusIcon?: boolean;
  onClick: () => void;
};

export const SimpleDocument = ({
  document,
  onClick,
  noStatusIcon,
}: InputProps) => {
  const canUpload = useMemo(() => {
    return (
      !!document.status &&
      ![
        DocumentStatusEnum.UPLOADED,
        DocumentStatusEnum.NEEDS_REVIEW,
        DocumentStatusEnum.APPROVED,
      ].includes(document.status)
    );
  }, [document.status]);

  const handleClick = () => {
    if (canUpload) {
      onClick();
    }
  };

  return (
    <ContentListItem
      onClick={handleClick}
      icon={!noStatusIcon && <DocumentStatusIcon status={document.status} />}
      title={document.documentName}
      subtitle={
        noStatusIcon ? (
          <span className={styles.subtitleText}>Click to upload</span>
        ) : (
          <DocumentStatusText document={document} />
        )
      }
      button={<ArrowButton onClick={handleClick} disabled={!canUpload} />}
    />
  );
};
